/** @jsx jsx */
import { Fragment, h } from 'preact';

// Searchspring
import { getContext } from '@searchspring/snap-toolbox';

// Packages
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';

// Local
import { StarFull } from '../../Icons/StarFull';

import { Prices } from '../../Prices/Prices';
import { fetchLocaleField } from '../../Helpers';

// CSS
import '../../Result/result.css';

export function StandardProductCard({ cardProps: { parentProps, styling, parentSubProps } }) {
	// Destructure relevant data from parent component props
	const { result, className, layout, controller } = parentProps;

	const context = getContext(['region']);
	const core = result?.mappings?.core;

	const hoverImage = result?.attributes?.ss_image_hover;
	const priceRange = result?.attributes?.ss_price_range ? result?.attributes?.ss_price_range : null;
	const reviewScore = result?.attributes.reviews_product_score ? Number(result?.attributes.reviews_product_score) : null;
	const reviewTotal = result?.attributes.reviews_total_reviews;

	const badge = fetchLocaleField(result, 'mfield_cql_badge', 'mfield_french_badge');
	const arch_height = fetchLocaleField(result, 'mfield_cql_arch_height', 'mfield_french_arch_height');
	const insole_thickness = fetchLocaleField(result, 'mfield_cql_insole_thickness', 'mfield_french_insole_thickness');
	const underfoot_cushioning = fetchLocaleField(result, 'mfield_cql_underfoot_cushioning', 'mfield_french_underfoot_cushioning');

	// Handle fr product URL
	let productUrl = core.url;
	if (window.Shopify.locale == 'fr') {
		productUrl = `/fr${productUrl}`;
	}

	return (
		<article {...styling} className={classnames('ss__result', typeof hoverImage != 'undefined' && 'ss__result__hover', `ss__result--${layout}`, className)}>
			<a
				href={productUrl} //No variant selection on PLP, so extra logic not needed here.
				onMouseDown={(e) => {
					controller?.track?.product?.click(e, result);
				}}
				className="ss__result-link"
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						{badge && <div className="ss__badge ss__result__badge">{badge}</div>}
						<div {...styling} className={classnames('ss__image', 'ss__result__image')}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.4967637540453074"
								data-sizes="auto"
								data-image
								src={core.imageUrl}
							/>

							{typeof hoverImage != 'undefined' && (
								<img
									id={`ProductImage-${result.id}`}
									alt={core.name}
									class="product__img product__img--hover lazyload"
									data-aspectratio="1.4967637540453074"
									data-sizes="auto"
									data-image
									src={hoverImage}
								/>
							)}
						</div>
					</div>
					<div className="ss__result__details">
						<div className="ss__result__details__top_row body-large">
							<div className="ss__result__details__review">
								{reviewScore && reviewScore != null && (
									<>
										<StarFull />
										<span className="review-score">{reviewScore.toFixed(1)}</span>
										<span className="review-total">({reviewTotal})</span>
									</>
								)}
								{reviewScore == null && <div className="ss__results__no-reviews">{window.Resources.searchspring.productCards.noReviews}</div>}
							</div>

							<div className="ss__result__details__pricing body-medium">
								{context.region == 'us' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} />}

								{context.region == 'ca' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} />}

								{/* Only display UK prices if the market is equal to UK as well. */}
								{context.region == 'uk' && window.Resources.marketHandle == 'uk' && (
									<Prices priceRange={priceRange} core={core} subProps={parentSubProps} />
								)}
							</div>
						</div>

						<div className="ss__result__details__title body-medium">{core.name}</div>

						{(arch_height || insole_thickness || underfoot_cushioning) && (
							<div className="attributes-layout">
								{arch_height && (
									<div className="attribute-item attribute-item__arch-height">
										<span className="eyebrow eyebrow--small">{window.Resources.searchspring.productCards.productCardLabelArchHeight}</span>
										<span className="body-small">{arch_height}</span>
									</div>
								)}
								{insole_thickness && (
									<div className="attribute-item">
										<span className="eyebrow eyebrow--small">{window.Resources.searchspring.productCards.productCardLabelInsoleThickness}</span>
										<span className="body-small">{insole_thickness}</span>
									</div>
								)}
								{underfoot_cushioning && (
									<div className="attribute-item">
										<span className="eyebrow eyebrow--small">{window.Resources.searchspring.productCards.productCardLabelUnderfootCushion}</span>
										<span className="body-small">{underfoot_cushioning}</span>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</a>
		</article>
	);
}
